// libs
import React, { memo, useMemo } from 'react';

// styles
import { SizeChartStripContainer, Dot, StripContent } from './styles';

interface SizeDataArray {
  conversion: boolean;
  id: string;
  label: string;
  sizeName: string;
  type: string;
  value: string;
  unitLabel: string;
}

interface SelectedSizeChartProps {
  sizeData: {
    [key: string]: { [key: string]: SizeDataArray };
  };
  isBottomSheet?: boolean;
  isDesktopWishlist?: boolean;
}

const SelectedSizeChartStrip = ({
  sizeData,
  isBottomSheet = false,
  isDesktopWishlist = false,
}: SelectedSizeChartProps) => {
  const formatText = useMemo(() => {
    const sizedataEntries = [];
    let count = 0;
    const sizeDataArray = Object.values(sizeData);
    for (const data of sizeDataArray) {
      if (count >= 3) break;
      sizedataEntries.push(
        data.conversion ? (
          <>
            {data.label} {` `}
            <strong>
              {data.value} {data.unitLabel}
            </strong>
          </>
        ) : (
          <>
            {data.label} {` `} <strong>{data.value}</strong>
          </>
        )
      );
      count++;
    }
    return sizedataEntries.map((entry, index) => (
      <span key={index}>
        <span>{entry}</span>
        {index < sizedataEntries.length - 1 && <Dot />}
      </span>
    ));
  }, [sizeData]);

  return (
    <SizeChartStripContainer isBottomSheet={isBottomSheet} isDesktopWishlist={isDesktopWishlist}>
      <StripContent>{formatText}</StripContent>
    </SizeChartStripContainer>
  );
};

export default memo(SelectedSizeChartStrip);
